/* Special Order colour picker (Wedance, 2026-08).

   Stockable colours are real variants; the rest are line-item properties rendered by
   snippets/special-order-colour.liquid. Because a special colour is NOT a variant, nothing
   in Dawn drives the gallery when one is picked — so we do it here, reusing the exact
   mechanism variant-media-filter.js uses for real variants: move the media <li> to the front
   of the list and hand the id to media-gallery.setActiveMedia().

   The media for those colours stays on the product after their variants are deleted, so
   `data-media-id` still resolves. If it ever doesn't, we no-op rather than break add-to-cart. */
(function () {
  function galleryFor(sectionId) {
    // media-gallery is a SIBLING of <product-info>, so scope to the whole product section.
    var section =
      document.getElementById('MainProduct-' + sectionId) ||
      document.querySelector('.section-' + sectionId + '-padding') ||
      document;
    return section.querySelector('media-gallery') || document.querySelector('media-gallery');
  }

  function showColourMedia(sectionId, mediaId) {
    if (!sectionId || !mediaId) return;
    var gallery = galleryFor(sectionId);
    if (!gallery) return;
    var mid = sectionId + '-' + mediaId;
    var li = gallery.querySelector('li[data-media-id="' + mid + '"]');
    if (!li) return; // media no longer on the product — leave the gallery alone
    var list = li.parentElement;
    if (list && list.firstElementChild !== li) list.insertBefore(li, list.firstElementChild);
    if (typeof gallery.setActiveMedia === 'function') {
      try {
        gallery.setActiveMedia(mid, true);
      } catch (e) {
        /* gallery not ready — the <li> reorder above is enough */
      }
    }
  }

  /* Hide the special-order colours from the ordinary variant picker.

     They only still appear there because their variants haven't been deleted yet; the shopper
     should reach them through the Special Order block, not as stockable swatches. Doing it here
     means the PDP behaves exactly as it will post-deletion, so the design can be signed off
     while the data is still intact and reversible. After the variants are deleted this finds
     nothing and quietly does nothing. */
  function specialNames() {
    var el = document.querySelector('script[data-so-colour-list]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent).map(function (n) {
        return String(n).trim().toLowerCase();
      });
    } catch (e) {
      return null;
    }
  }

  function hideSpecialSwatches() {
    var names = specialNames();
    if (!names || !names.length) return;
    document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input').forEach(function (fs) {
      var lg = fs.querySelector('legend, .form__label');
      if (!lg || !/colou?r|material/i.test(lg.textContent || '')) return;
      fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        if (names.indexOf(String(inp.value).trim().toLowerCase()) === -1) return;
        var lbl =
          inp.nextElementSibling && inp.nextElementSibling.tagName === 'LABEL' ? inp.nextElementSibling : null;
        // never hide the one currently selected, or the picker would look empty//broken
        if (inp.checked) return;
        inp.setAttribute('data-so-hidden', '');
        inp.style.setProperty('display', 'none', 'important');
        if (lbl) lbl.style.setProperty('display', 'none', 'important');
      });
      // dropdown pickers
      fs.querySelectorAll('select option').forEach(function (o) {
        if (o.selected) return;
        if (names.indexOf(String(o.value).trim().toLowerCase()) > -1) o.remove();
      });
    });
  }

  /* Show the block only while the "Special Order" colour is selected.

     This CANNOT be left to Liquid: Dawn 15 re-renders only #price/#Sku/#Inventory/#Volume/
     #Price-Per-Item, the variant picker and the media on a variant change — never this region.
     So we read the picker's current colour ourselves and toggle. Inputs are disabled whenever the
     block is hidden, which is what actually guarantees a hidden panel can't submit a stale
     "Colour: …" property against a stockable variant. */
  function selectedColour(scope) {
    var fields = (scope || document).querySelectorAll(
      'variant-selects fieldset, variant-selects .product-form__input'
    );
    for (var i = 0; i < fields.length; i++) {
      var lg = fields[i].querySelector('legend, .form__label');
      if (!lg || !/colou?r|material/i.test(lg.textContent || '')) continue;
      var checked = fields[i].querySelector('input[type="radio"]:checked');
      if (checked) return String(checked.value).trim();
      var sel = fields[i].querySelector('select');
      if (sel) return String(sel.value).trim();
    }
    return null;
  }

  /* Gate Add to Cart while a Special Order colour is required but unchosen.

     `required` alone does nothing here: buy-buttons.liquid renders the product form with
     `novalidate`, so the browser never runs constraint validation, and Dawn adds to cart via
     fetch rather than a native submit. Dawn's own product-form.js does bail out of
     onSubmitHandler when the submit button carries aria-disabled="true", so we drive that —
     working with the theme instead of intercepting around it. We only ever clear the flag we
     set ourselves (data-so-blocked), so a genuine sold-out state is never overridden. */
  function submitButtonFor(group) {
    var form = document.getElementById(
      (group.querySelector('input[name="properties[Colour]"]') || {}).getAttribute
        ? group.querySelector('input[name="properties[Colour]"]').getAttribute('form')
        : ''
    );
    var host = form ? form.closest('product-form') || form : document;
    return host.querySelector('[type="submit"]');
  }

  function setBlocked(group, blocked) {
    var btn = submitButtonFor(group);
    if (!btn) return;
    if (blocked) {
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('data-so-blocked', '');
    } else if (btn.hasAttribute('data-so-blocked')) {
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('data-so-blocked');
    }
    /* Always explain a disabled button. Earlier this only appeared after a click attempt, which
       left Add to Cart inert with no stated reason — and depended on a click path that proved
       unreliable. Now the hint shows whenever the button is blocked, and only turns into a
       red error once the shopper has actually tried. */
    var note = group.querySelector('[data-so-error]');
    if (note) {
      note.hidden = !blocked;
      note.classList.toggle('so-colour__error--tried', blocked && group.hasAttribute('data-so-tried'));
    }
  }

  function syncVisibility() {
    document.querySelectorAll('[data-special-order-colour]').forEach(function (group) {
      var want = group.getAttribute('data-special-value') || 'Special Order';
      var current = selectedColour(document);
      var active = current !== null && current.toLowerCase() === want.toLowerCase();
      if (active) group.removeAttribute('hidden');
      else group.setAttribute('hidden', '');
      var chosen = false;
      group.querySelectorAll('input[name="properties[Colour]"]').forEach(function (inp) {
        inp.disabled = !active;
        if (!active) inp.checked = false; // never carry a stale colour back to a stockable variant
        if (inp.checked) chosen = true;
      });
      if (!active) group.removeAttribute('data-so-tried');
      setBlocked(group, active && !chosen);
    });
  }

  function refresh() {
    hideSpecialSwatches();
    syncVisibility();
  }

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(refresh, 80);
    });
  }
  /* Belt and braces: the picker also fires plain change events, and on some paths the pub-sub
     event lands before the picker DOM settles. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(refresh, 0);
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    if (input.name !== 'properties[Colour]') return;
    var field = input.closest('[data-special-order-colour]');
    if (!field) return;
    showColourMedia(field.getAttribute('data-section'), input.getAttribute('data-media-id'));
    /* Re-run the gate. Without this the aria-disabled flag set while no colour was chosen is
       never cleared — these radios live OUTSIDE <variant-selects>, so the other change listener
       (scoped to the picker) never fires for them, and Add to Cart stays dead permanently. */
    syncVisibility();
  });

  /* Belt and braces on top of the aria-disabled gate: catch the click (capture phase, so it runs
     before Dawn's handlers) to reveal the inline error and scroll the block into view. The
     aria-disabled flag is what actually stops the add; this is the part the shopper sees. */
  function guard(e) {
    var group = document.querySelector('[data-special-order-colour]:not([hidden])');
    if (!group) return;
    var radios = group.querySelectorAll('input[name="properties[Colour]"]:not([disabled])');
    if (!radios.length) return;
    var chosen = Array.prototype.some.call(radios, function (r) {
      return r.checked;
    });
    /* A colour IS chosen: make sure we aren't still holding the button shut. Belt and braces —
       if any path ever leaves a stale aria-disabled behind, this releases it on the next click
       rather than leaving the shopper with a dead button. */
    if (chosen) {
      syncVisibility();
      return;
    }
    var btn = e.target && e.target.closest ? e.target.closest('[type="submit"]') : null;
    if (e.type === 'click' && !btn) return;
    e.preventDefault();
    e.stopPropagation();
    group.setAttribute('data-so-tried', '');
    syncVisibility();
    group.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
})();
